import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function Pricing() {
  const {
    t
  } = useLanguage();
  return <section id="pricing" className="py-24 px-6 bg-cream" data-id="element-89">
      <div className="max-w-4xl mx-auto" data-id="element-90">
        <h2 className="font-serif text-4xl md:text-5xl mb-16 text-center" data-id="element-91">
          {t.pricing.h2Part1}{' '}
          <span className="italic text-coral" data-id="element-92">{t.pricing.h2Italic}</span>
        </h2>

        <div className="bg-surface border border-taupe rounded-3xl p-8 md:p-12 mb-16" data-id="element-93">
          <div className="space-y-6 mb-12" data-id="element-94">
            {t.pricing.benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-95">
                <div className="mt-1 bg-coral/10 p-1 rounded-full" data-id="element-96">
                  <Check className="w-4 h-4 text-coral" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <p className="font-medium text-ink text-lg" data-id="element-99">
                    {benefit.title}
                  </p>
                  <p className="text-muted" data-id="element-100">{benefit.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="border-t border-taupe pt-12" data-id="element-101">
            <h3 className="font-serif text-3xl mb-8 text-center" data-id="element-102">
              {t.pricing.priceTitle}
            </h3>

            <div className="space-y-4 mb-12 max-w-md mx-auto" data-id="element-103">
              <div className="flex justify-between items-center p-4 border-b border-taupe/50 text-muted line-through" data-id="element-104">
                <span data-id="element-105">{t.pricing.compare1Label}</span>
                <span data-id="element-106">{t.pricing.compare1Price}</span>
              </div>
              <div className="flex justify-between items-center p-4 border-b border-taupe/50 text-muted line-through gap-4" data-id="element-107">
                <span data-id="element-108">{t.pricing.compare2Label}</span>
                <span className="text-right" data-id="element-109">{t.pricing.compare2Price}</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-coral/5 border border-coral/20 rounded-xl text-ink font-medium text-xl" data-id="element-110">
                <span data-id="element-111">{t.pricing.compare3Label}</span>
                <span className="text-coral" data-id="element-112">{t.pricing.compare3Price}</span>
              </div>
            </div>

            <p className="text-center text-lg text-ink/80 mb-12" data-id="element-113">
              {t.pricing.priceClosing}
            </p>

            <div className="text-center space-y-6 mb-12" data-id="element-114">
              <h4 className="font-serif text-2xl italic" data-id="element-115">
                {t.pricing.noRiskTitle}
              </h4>
              <p className="text-lg text-ink/80" data-id="element-116">{t.pricing.noRisk1}</p>
              <p className="text-lg text-ink/80" data-id="element-117">{t.pricing.noRisk2}</p>
              <p className="text-lg text-ink/80" data-id="element-118">{t.pricing.noRisk3}</p>
            </div>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-119">
          <h3 className="font-serif text-3xl mb-6" data-id="element-120">{t.pricing.finalTitle}</h3>
          <p className="text-xl text-ink/80 mb-4" data-id="element-121">{t.pricing.final1}</p>
          <p className="text-lg text-ink/80 mb-4" data-id="element-122">{t.pricing.final2}</p>
          <p className="text-lg text-ink/80 mb-12" data-id="element-123">{t.pricing.final3}</p>

          <p className="font-serif text-2xl italic text-coral mb-8" data-id="element-124">
            {t.pricing.finalItalic}
          </p>

          <a href="https://mycodeex.com" className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 bg-coral text-white font-medium rounded-full hover:bg-coral/90 transition-transform hover:scale-105 active:scale-95 text-lg" data-id="element-125">
            {t.pricing.finalCta}
          </a>

          <p className="mt-4 text-sm text-muted" data-id="element-126">{t.pricing.finalDisclaimer}</p>
        </div>
      </div>
    </section>;
}